import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import AuthenticationLayoutUko from "../../../components/AuthenticationLayoutUko/AuthenticationLayoutUko";
import { Grid,  useTheme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PrimaryButtonUko from "../../../components/primaryButtonUko.component";
import { isEmpty } from "../../../utils/proprietaryHooks";
import { getVersionAppAction } from "../../../actions/applications.action";
import Box from '@material-ui/core/Box';


const SuccessAlertUko = (props) =>{
    const {
        appName,
        getVersionApp,
    } = props
    const theme = useTheme();
    const classes = useStyles();
    const [versionMessage, setVersionMessage] = useState("");

    useEffect(() => {
        if (appName && appName !== "") {
            getVersionAppAction(appName);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    useEffect(() => {
        if (!isEmpty(getVersionApp)) {
            setVersionMessage(getVersionApp.version);
        }
    }, [getVersionApp])


    return (
        <AuthenticationLayoutUko title="¡Contraseña actualizada!" logoApp={theme.urlLogo.urlSuccessAlertlogo} logoSignIn={theme.urlLogo.urlSignIn}>
            <form id="cambiarcontraseña-validation" autoComplete="off">
                <Grid container direction="column" style={{ marginTop: "40px", gap: "16px" }}>
                    <PrimaryButtonUko
                        txtBtn={"iniciar sesión"}
                        href="/login"
                        loading={false}
                    />
                </Grid>
            </form>
            <div style={{ display: 'flex', flexFlow: 'wrap', justifyContent: 'space-between', marginTop: '24px', marginBottom: '24px' }} ></div>
            <Box className={classes.version}>
                <p>{versionMessage}</p>
            </Box>
        </AuthenticationLayoutUko>
    );
};

const useStyles = makeStyles((theme) => ({
    version: {
        fontSize: '14px',
        fontWeight: 500,    
        color: theme.versionUko.colorVersionLabel,    
        position: 'absolute',
        bottom: '15px',
        left: '50%',
        right: '0',
        textAlign: 'center',
        [theme.breakpoints.down('md')]: {
            position: 'static',
        },
    },
}));


const mapStateToProps = (state) => ({
    getVersionApp: state.applicationsReducer.getVersionApp,
});
export default connect(mapStateToProps, {
    getVersionAppAction,
})(SuccessAlertUko);